import router from '@/router'

const state = {
  breadcrumbs: [], // 面包屑
  currentSelect: {} // 当前选中的面包屑
}

const getters = {
  getBreadcrumbs: state => state.breadcrumbs, // 获取面包屑列表
  getCurrentSelect: state => state.currentSelect // 获取当前选中的面包屑
}

const mutations = {
  setBreadcrumbs (state, breadcrumb) {
    const index = state.breadcrumbs.findIndex(b => b.name === breadcrumb.name)
    if (index === -1) {
      state.breadcrumbs.push(breadcrumb)
    } // else, 不添加，因为它已经存在
  },

  setCurrentSelect (state, breadcrumb) {
    state.currentSelect = breadcrumb
  },

  clearBreadcrumbs (state) {
    state.breadcrumbs = []
    state.currentSelect = {}
  },

  updateBreadcrumbs (state, breadcrumb) {
    const index = state.breadcrumbs.findIndex(b => b.path === breadcrumb.path)
    if (index !== -1) {
      state.breadcrumbs[index] = breadcrumb
    } else {
      state.breadcrumbs.push(breadcrumb)
    }
  },

  removeBreadcrumbs (state, name) {
    // state.breadcrumbs = state.breadcrumbs.filter(item => item.name !== name)
    // router.go(-1)
    // state.currentSelect = state.breadcrumbs[state.breadcrumbs.length - 1]
    // state.breadcrumbs = state.breadcrumbs.filter(b => b.name !== name)
    // // 更新当前选中的面包屑，若已删除则选择最后一个
    // if (state.currentSelect.name === name) {
    //   state.currentSelect = state.breadcrumbs[state.breadcrumbs.length - 1] || {}
    // }
    const index = state.breadcrumbs.findIndex(b => b.name === name)
    if (index !== -1) {
      // 如果删除的面包屑是当前选中的，或者是最后一个，需要进行路由跳转
      const isCurrentSelect = state.breadcrumbs[index].name === state.currentSelect.name
      const isLastBreadcrumb = index === state.breadcrumbs.length - 1

      state.breadcrumbs.splice(index, 1)

      if (isCurrentSelect || isLastBreadcrumb) {
        if (state.breadcrumbs.length > 0) {
          // 设置新的当前选中的面包屑并跳转
          const newCurrentSelect = state.breadcrumbs[state.breadcrumbs.length - 1]
          state.currentSelect = newCurrentSelect
          router.push(newCurrentSelect.path)
        } else {
          // 面包屑为空，跳转到默认页面
          state.currentSelect = {}
          // router.push('/default-route')
        }
      }
    }
  }
}

const actions = {
  updateBreadcrumbs ({ commit }, breadcrumb) {
    commit('updateBreadcrumbs', breadcrumb)
  },

  removeBreadcrumbs ({ commit }, name) {
    commit('removeBreadcrumbs', name)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
